import React from "react";
import TextInfo from "@/bit/components/next13.components.text";

const Item = ({ className, charac, index, displayLine }) => {
  return (
    <div
      className={`${className} steps-characteristics--row`}
      key={`steps-characteristics--${index}`}
      data-cy={`Step-List-Item Step-List-Item`}
    >
      <div className="steps-characteristics--row--icon">
        <div className="steps-characteristics--row--iconRight">
          <p>{index + 1}</p>
        </div>
        {displayLine && <div className="steps-characteristics--row--gap"></div>}
      </div>
      <div className="steps-characteristics--row--text">
        {charac["Text-1"] && charac["Text-1"].text && (
          <TextInfo
            {...charac["Text-1"]}
            cyData={`MainCharacteristic-${index} Title`}
          />
        )}
        {charac["Text-2"] && charac["Text-2"].text && (
          <TextInfo
            {...charac["Text-2"]}
            cyData={`MainCharacteristic-${index} Description`}
          />
        )}
      </div>
    </div>
  );
};

export default Item;
